// removed by extract-text-webpack-plugin
module.exports = {"select":"ZS3yoqsEgjGs_MFZqsJJN","placeholderColor":"qkn0Kfb1TEELL-Hestcp_"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/form/Form.scss
// module id = 291
// module chunks = 12